import { createStore as crStore, applyMiddleware, Middleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { identity } from '../lib/functional/identity';
import { getRootReducer } from './getRootReducer';
import { getRootSaga } from './sagas/getRootSaga';

const composeEnhancers =
    process.env.NODE_ENV === 'development' || process.env.OT_REDUX_TOOLS === 'on' ? composeWithDevTools({}) : compose;

export const createStore = (...middleware: Middleware[]) => {
    const sagaMiddleware = createSagaMiddleware();
    const store = crStore(
        compose(identity)(getRootReducer()),
        composeEnhancers(applyMiddleware(sagaMiddleware, ...middleware)),
    );
    sagaMiddleware.run(getRootSaga);
    return store;
};
